import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { getSKUData, handleLoader } from '../../../../redux/actions/SKUAction';
import ImportSearchPositionTrackerExcel from './ImportSearchPositionTrackerExcel';

const UploadSearchPositionTracker = ({ dispatch }) => {
  const { t } = useTranslation('common');
  const location = useLocation();

  const { skuData, salesChannelFilterData, isLoading } = useSelector(
    ({ SKUReducer, marketPlaceReducer }) =>
    ({
      skuData: SKUReducer.skuData,
      salesChannelFilterData: marketPlaceReducer.salesChannel,
      isLoading: SKUReducer?.isLoading
    })
  );    
  
  const skuOption = []; 

  useEffect(() => {
    dispatch(handleLoader(true));
    dispatch(getSKUData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  skuData?.modal?.filters?.sort((a, b) => a.sortingOrder - b.sortingOrder).forEach((data) => {
    data.filterData.forEach((element) => {
        skuOption.push({
            value: element.key,
            label: element.shortValue
        });
    });
  });  

  const skuRecords = {
    skuOptions: skuOption
  }

  return (
    <Container>
      <Card className="pb-3">
        <CardBody className="dashboard__card-widget card-shadow p-3">
          <CardTitle className="bold-text text-center" tag="h3">
            Upload Search Position Tracker
          </CardTitle>          
        </CardBody>
      </Card>
      <Row className="product-table-wrap">        
          <Col sm="12">
            <CardBody>  
            {isLoading ? 
                    <div style={{ minHeight: '200px' }}
                        className="row align-items-center justify-content-center">
                        <SmallLoader loading={isLoading} />
                    </div> 
                  : 
                <ImportSearchPositionTrackerExcel {...skuRecords} />  
            }        
            </CardBody>
          </Col>     

      </Row>
    </Container>
  )
};

UploadSearchPositionTracker.propTypes = {
  dispatch: PropTypes.func.isRequired,
}

export default connect(state => ({
  rtl: state.rtl,
}))(UploadSearchPositionTracker);